// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"06d8b15e","204":"f3498144","727":"4f3bc10d","765":"555d131e"}[chunkId] + ".chunk.css";
};